module.exports = __webpack_public_path__ + "static/img/公民師資介紹.b4f203e5.png";